import { matchRoutes, RouteObject, useLocation } from "react-router";

export const usePathOrRouteMatcher = () => {
  const location = useLocation();
  const { pathname } = location;

  const matchesPath = (pathOrPaths: string | string[]) =>
    Array.isArray(pathOrPaths)
      ? pathOrPaths.includes(pathname)
      : pathname === pathOrPaths;

  const matchesRoutes = (routes: RouteObject[]) =>
    Boolean(matchRoutes(routes, location));

  return {
    matchesPath,
    matchesRoutes,
  };
};
